import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IntegrationBackSC } from './integration.styled';

type TProps = {
  onClick(): void;
};

const IntegrationBack: React.FC<TProps> = ({ onClick }) => (
  <IntegrationBackSC>
    <span onClick={onClick}>
      <img src={require('../../assets/svg/icon-chevron-left.svg').default} height="14" alt="" />
      <FormattedMessage id="integration.back" />
    </span>
  </IntegrationBackSC>
);

export default IntegrationBack;
